import { createDeferred } from '@/shared/lib/deferred';
import type { McapPreflightResult } from './preflight';

export async function runMcapPreflight(file: File): Promise<McapPreflightResult> {
  if (typeof Worker === 'undefined') {
    return { status: 'inconclusive', reason: 'preflight_worker_unavailable' };
  }
  let worker: Worker | undefined;
  try {
    worker = new Worker(new URL('./preflight.worker.ts', import.meta.url), { type: 'module' });
    const { promise, resolve } = createDeferred<McapPreflightResult>();
    let settled = false;
    const finish = (result: McapPreflightResult) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      resolve(result);
    };
    const timeout = setTimeout(
      () => finish({ status: 'inconclusive', reason: 'preflight_worker_timeout' }),
      10_000,
    );
    worker.onmessage = (event: MessageEvent<McapPreflightResult>) => finish(event.data);
    worker.onerror = () => finish({ status: 'inconclusive', reason: 'preflight_worker_failed' });
    try {
      worker.postMessage({ file });
    } catch {
      finish({ status: 'inconclusive', reason: 'preflight_worker_post_failed' });
    }
    return await promise;
  } catch {
    return { status: 'inconclusive', reason: 'preflight_worker_failed' };
  } finally {
    worker?.terminate();
  }
}
